/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"overlay":"overlay_ewlVG","_overflow":"_overflow_K4qHR"};